import { FC, useState } from "react";
import Modal from "react-modal";
import { CrossIcon } from "../../assets";
import { Button, Radio } from "../../components";
import { muteUser } from "../../services/users.service";
import styles from "./styles.module.scss";
import { toast } from "react-hot-toast";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  userId: number;
  onGetUserInfo: () => void;
  refetchUsers: () => void;
}

const MuteUser: FC<Props> = ({
  isOpen,
  setIsOpen,
  userId,
  onGetUserInfo,
  refetchUsers,
}): JSX.Element => {
  const [muteType, setMuteType] = useState<
    "tomorrow" | "nextWeek" | "indefinitely"
  >("tomorrow");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onMuteUser = async () => {
    try {
      setIsLoading(true);
      await muteUser(userId, muteType);
      onGetUserInfo();
      refetchUsers();
      setIsOpen(false);

      setIsLoading(false);
    } catch (error) {
      toast.error(error?.message?.[0]?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      shouldFocusAfterRender={false}
      onRequestClose={() => setIsOpen(false)}
      overlayClassName={styles.overlay}
      className={styles.modal}
      ariaHideApp={false}
    >
      <div className={styles.innerContainer}>
        <CrossIcon
          onClick={() => setIsOpen(false)}
          className={styles.closeBtn}
        />
        <h5>Ignore user</h5>
        <div className={styles.optionsContainer}>
          <div className={styles.blockReasonWrapper}>
            <p className={styles.title}>Ignore user until:</p>
            <div className={styles.reasonList}>
              {[
                { title: "Tomorrow", value: "tomorrow" },
                { title: "Next Week", value: "nextWeek" },
                { title: "Indefinitely", value: "indefinitely" },
              ].map((item, index) => {
                return (
                  <div key={index} className={styles.radioOption}>
                    <Radio
                      isCheked={muteType === item.value}
                      setIsCheked={() =>
                        setMuteType(
                          item.value as "tomorrow" | "nextWeek" | "indefinitely"
                        )
                      }
                    />
                    <p className={styles.radioTitle}>{item.title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <Button
            title={"Ignore"}
            size={"small"}
            loading={isLoading}
            onClick={onMuteUser}
            styleType="filled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default MuteUser;
